module.exports = __webpack_public_path__ + "media/src/images/icon__mail--dark-270b9d6f737470c734a0eab25aa91a7d.png";